import { Contract, ContractInterface, providers, utils } from 'ethers'
import { Interface } from 'ethers/lib/utils'

export type ContractType<C> = Contract & C

export class ContractUtils<C> {
  ABI: Exclude<ContractInterface, Interface>
  provider: providers.JsonRpcProvider

  constructor (ABI: Exclude<ContractInterface, Interface>, rpc: string) {
    this.ABI = ABI
    this.provider = new providers.JsonRpcProvider(rpc)
  }

  encode<F extends keyof C, P extends C[F]> (func: F, params: Parameters<P | any>) {
    console.log('encode', name, func, params)

    const inter = new utils.Interface(this.ABI)

    return inter.encodeFunctionData(func as string, params)
  }
}
